export default __webpack_public_path__ + "static/media/EWIC.b3c54b11.png";